/**
 * 초안이 알려 준 슬라이드 가운데 **사례의 그림으로 넣을 것**을 고른다 — 순수 함수(CaseRegisterForm · 백엔드 tuningCase/slideRender).
 *
 * 「이 사례가 어느 슬라이드에 실렸나」 는 초안(AI)이 말하고, 「그 슬라이드가 도식인가」 는 기계가 센다(도형 수 — 글 상자·표만 있는
 * 쿼리·실행계획 슬라이드는 글로 옮기므로 그림으로 넣지 않는다). AI 가 말한 번호가 실제로 없으면 그냥 빠진다.
 */

/** 자동으로 넣는 장 수의 상한 — 넘는 것은 그림 탭에서 직접 고른다(사례 하나에 그림이 줄줄이 붙지 않게) */
export const AUTO_SLIDE_FIGURES = 6;

/**
 * @param list     슬라이드 목록 [{ no, fileNo, isDiagram, … }] (서버가 준 것)
 * @param slideNos 초안이 말한 번호(파일 번호 — 글 추출의 `--- slides/slideN.xml ---` 표식)
 * @returns 넣을 슬라이드(보이는 순서대로, 상한까지)
 */
export function pickDiagramSlides(list, slideNos, max = AUTO_SLIDE_FIGURES) {
  const want = new Set((slideNos || []).map(Number).filter(Number.isInteger));
  if (!want.size) return [];
  return (list || [])
    .filter(m => m && m.isDiagram && !m.error && want.has(Number(m.fileNo || m.no)))
    .sort((a, b) => a.no - b.no)
    .slice(0, Math.max(0, max));
}

export default pickDiagramSlides;
